import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Chip,
  Stack,
  Paper,
  IconButton,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import styles from "./TermsConditionList.module.scss";
import axiosInstance from "../../../../services/apis/axiosInstance";

const TermsConditionList = () => {
  const [policy, setPolicy] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        const res = await axiosInstance.get(`/singleton/termsCondition`);
        const data1 = res.data;
        if (data1 && data1?.isActive) {
          setPolicy(data1);
        }
      } catch (error) {
        console.error("Error fetching terms & condition:", error);
      }
    };

    fetchPolicy();
  }, []);

  const handleAdd = () => {
    navigate("/pages/terms-condition/add");
  };

  const handleEdit = () => {
    navigate("/pages/terms-condition/add", { state: { policy } });
  };

  return (
    <Box className={styles.wrapper}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h5" className={styles.heading}>
          Terms & Condition
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAdd}>
          Add Terms & Condition
        </Button>
      </Box>

      {policy && (
        <Paper elevation={1} className={styles.policyPaper}>
          <Box className={styles.status}>
            <Chip
              label={policy?.isActive ? "Active" : "Inactive"}
              color={policy?.isActive ? "success" : "default"}
              size="small"
            />
          </Box>

          <Stack spacing={3}>
            <Box>
              <Typography variant="subtitle1" className={styles.label}>
                Description:
              </Typography>
              <Box className={styles.scrollBox}>{policy?.data?.en}</Box>
            </Box>

            <Box>
              <Typography variant="subtitle1" className={styles.label}>
                विवरण:
              </Typography>
              <Box className={styles.scrollBox}>{policy?.data?.hi}</Box>
            </Box>

            <Box>
              <Typography variant="subtitle1" className={styles.label}>
                Comment
              </Typography>
              <Typography>{policy?.comment}</Typography>
            </Box>
          </Stack>

          <Box className={styles.topBar}>
            <Box className={styles.iconButtons}>
              <IconButton color="primary" onClick={handleEdit}>
                <EditIcon />
              </IconButton>
            </Box>
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default TermsConditionList;
